import { http } from "@shared/utils/request";

export interface StoreOptionItem {
    id: string;
    corpId: string;
    storeName: string;
    platform: number;
    platformLabel: string;
    countryCode: string;
    /** 部分店铺接口会带 VC Code，用于 LISTING 等筛选项 */
    vcCode?: string;
}

interface StoreOptionsData {
    items: StoreOptionItem[];
}

/** 全部启用店铺下拉选项 */
export function fetchStoreOptions(): Promise<StoreOptionsData> {
    return http.get<StoreOptionsData>("/manage/store/options");
}

export interface StoreVcCodeItem {
    id: string;
    name: string;
    code: string | null;
    type: string;
}

export interface StoreVcOptionItem {
    id: string;
    sellerId: string;
    sellerName: string;
    storeName: string;
    platform: number;
    platformLabel: string;
    countryCode: string;
    isActive: number;
    /** 部分接口会把 VC Code 直接挂在店铺上 */
    vcCode?: string;
    vcCodes: StoreVcCodeItem[];
}

interface StoreVcOptionsData {
    items: StoreVcOptionItem[];
}

/** 亚马逊 VC 店铺及 vcCodes（核价 / 筛选下拉） */
export function fetchStoreVcOptions(): Promise<StoreVcOptionsData> {
    return http.get<StoreVcOptionsData>("/manage/store/vcOptions");
}

/** 沃尔玛店铺及 DSV Code（核价 / 筛选下拉，结构与 vcOptions 一致） */
export function fetchStoreWalmartDsvOptions(): Promise<StoreVcOptionsData> {
    return http.get<StoreVcOptionsData>("/manage/store/walmartDsv");
}
